module.exports = __webpack_public_path__ + "static/media/prestamos.fe530bca.svg";